import { render, staticRenderFns } from "./SemaforoVerde.vue?vue&type=template&id=2007089b&scoped=true&"
import script from "./SemaforoVerde.vue?vue&type=script&lang=js&"
export * from "./SemaforoVerde.vue?vue&type=script&lang=js&"
import style0 from "./SemaforoVerde.vue?vue&type=style&index=0&id=2007089b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2007089b",
  null
  
)

export default component.exports